import React, { useEffect, useState } from 'react';

import './style.css';
import { AutoComplete, Form, Input, Layout, Menu, Pagination } from 'antd';
import { useLayoutsStore } from '../../../store/layout/useLayoutsStore';
import { useFindLayoutsStore } from '../../../store/layout/useFindLayoutStore';
import MainMenu from '../../../components/menu/Menu';
import ButtonAddPlus from '../../../components/buttons/buttonAddPlus/ButtonAddPlus';
import NewLayoutModal from '../../../components/modals/newLayout/NewLayoutModal';
import { ReactComponent as SearchImg } from 'utils/app/assets/icons/search.svg';
import LayoutComponentDevice from './components/LayoutComponentDevice/LayoutComponentDevice';
import Buttonsfilter from '../../../components/buttons/buttonFilter/Buttonsfilter';
import LayoutComponent from './components/LayoutComponent/LayoutComponent';
import LayoutsTable from './tables/LayoutsTable/LayoutsTable';
import { useNavigate } from 'react-router-dom';
import { LayoutType } from '../../../types/LayoutType';
import { useSelectedLayout } from '../../../store/useSelectedLayout';
import { AddDeviceModal } from './pages/layout/components/modals/AddDeviceModal/AddDeviceModal';
import { Device } from '../../../types/Device';

const { Header, Content, Footer } = Layout;

const LayoutsV2: React.FC = () => {
    const [currentMenuItem, setCurrentMenuItem] = useState('layouts');
    const [searchText, setSearchText] = useState('');
    const { allLayouts, fetchLayouts } = useLayoutsStore();
    const { FoundLayouts, fetchFoundLayouts } = useFindLayoutsStore();
    const [showAddLayoutModal, setShowAddLayoutModal] = useState(false);
    const [activeDeviceSize, setActiveDeviceSize] = useState<'small' | 'medium' | 'big'>(() => {
        const savedSize = localStorage.getItem('layoutsViewSize');
        return (savedSize as 'small' | 'medium' | 'big') || 'small'; // По умолчанию 'small'
    });
    console.log(activeDeviceSize);
    const [addDeviceModal, setAddDeviceModal] = useState(false);
    const [currentLayoutForModal, setCurrentLayoutForModal] = useState<LayoutType | null>(null);
    const navigate = useNavigate();

    const handleOpenAddDeviceModal = (layout: LayoutType) => {
        setCurrentLayoutForModal(layout);
        setAddDeviceModal(true);
    };

    const handleAddDeviceSuccess = async () => {
        await fetchLayouts();
        setAddDeviceModal(false);
    };

    const { selectedLayout, setSelectedLayout } = useSelectedLayout();
    console.log(selectedLayout);
    const handleLayoutClick = (layout: LayoutType) => {
        navigate(`/layout/${layout.uid}`);
        setSelectedLayout(layout);
    };

    const handleFilterButtonClick = (size: 'small' | 'medium' | 'big') => {
        setActiveDeviceSize(size);
    };

    const handleMenuClick = (key: string) => {
        setCurrentMenuItem(key);
    };

    const handleAddLayout = () => {
        setShowAddLayoutModal(true);
    };

    useEffect(() => {
        fetchLayouts();
    }, [searchText, activeDeviceSize]);

    const handleOkLayoutModal = () => {
        fetchLayouts();
        setShowAddLayoutModal(false);
    };

    const handleCancelLayoutModal = () => {
        setShowAddLayoutModal(false);
    };

    const filteredLayouts = allLayouts
        .filter((layout) => layout.name.toLowerCase().includes(searchText.toLowerCase()))
        .map((layout) => ({
            ...layout,
            devices: layout.devices || [],
        }));

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <div className="menu">
                    <MainMenu onClick={handleMenuClick} currentMenuItem={currentMenuItem} />
                </div>
            </Header>

            <div className="layouts_page">
                <div className="header_layouts">
                    <div className="left_HT">
                        <div className="Users">
                            <h1 className="name">Раскладки</h1>
                            <h1 className="count">({filteredLayouts.length})</h1>
                            <ButtonAddPlus onClick={handleAddLayout} />
                        </div>
                    </div>
                    <div className="right_HT">
                        <Input
                            placeholder={'Поиск'}
                            className="right_HT_input"
                            suffix={<SearchImg />}
                            value={searchText} // Устанавливаем значение текста поиска
                            onChange={(e) => setSearchText(e.target.value)} // Обработчик изменения текста поиска
                        />
                        <Buttonsfilter
                            onFilterButtonClick={handleFilterButtonClick}
                            storageKey="layoutsViewSize"
                        />
                    </div>
                </div>
                {activeDeviceSize === 'small' ? (
                    // Отображаем таблицу только для small
                    <LayoutsTable handleLayoutClick={handleLayoutClick} />
                ) : (
                    // Отображаем другие виды для medium и big
                    <div className={`body_layouts body_layouts--${activeDeviceSize}`}>
                        {filteredLayouts.map((layoutItem) => (
                            <>
                                <div
                                    key={layoutItem.uid}
                                    className={`body_layouts-container body_layouts-container--${activeDeviceSize}`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleLayoutClick(layoutItem)}
                                >
                                    {activeDeviceSize !== 'medium' && (
                                        <div className="body_layouts-container_header">
                                            <span
                                                className={'title large'}
                                                style={{ color: 'var(--gray-black)' }}
                                            >
                                                {layoutItem.description}
                                            </span>
                                            <span
                                                className={'title large'}
                                                style={{ color: 'var(--gray-02)', marginLeft: 8 }}
                                            >
                                                ({layoutItem.devices.length})
                                            </span>
                                            <ButtonAddPlus
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Предотвращаем всплытие события
                                                    handleOpenAddDeviceModal(layoutItem);
                                                }}
                                            />
                                        </div>
                                    )}

                                    {activeDeviceSize === 'medium' ? (
                                        <div className={'body_layouts-container_items--medium'}>
                                            <LayoutComponent
                                                handleAddLayout={() =>
                                                    handleOpenAddDeviceModal(layoutItem)
                                                }
                                                // key={device.ID}
                                                // device={device}
                                                layout={layoutItem}
                                            />
                                        </div>
                                    ) : (
                                        <div className={'body_layouts-container_items'}>
                                            {layoutItem.devices.map((device) => (
                                                <LayoutComponentDevice
                                                    key={device.ID}
                                                    device={device}
                                                    layout={layoutItem}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </>
                        ))}
                    </div>
                )}
            </div>
            <AddDeviceModal
                layout={currentLayoutForModal!}
                existingDevices={
                    currentLayoutForModal?.devices?.map((device: Device) => device.UID) || []
                }
                title={'Добавить устройство'}
                onCancel={() => {
                    setAddDeviceModal(false);
                }}
                setIsModalVisible={setAddDeviceModal}
                onOk={handleAddDeviceSuccess}
                visible={addDeviceModal}
            />
            <NewLayoutModal
                visible={showAddLayoutModal}
                onCancel={handleCancelLayoutModal}
                onOk={handleOkLayoutModal}
            />
        </Layout>
    );
};

export default LayoutsV2;
